exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:992px){Dashboard .no_padding_left,Dashboard .no_padding_right{padding:inherit!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/dashboard/dashboard.scss
// module id = 1025
// module chunks = 0